import { ComponentVerticalPlacementType } from "building-types/components/componentInstanceTypes";
import type { ComponentTransformVerticalPlacement } from "building-types/components/componentTypes";
import type { Level } from "building-types/levels/levelTypes";
import type { Table } from "common/data/table";
import { assertUnreachable } from "common/utils/assertUnreachable";
import { instanceIdForComponent } from "doc/entity/componentInstanceEntityResolve";

export function componentInstanceLevelId(
  originalLevelId: string,
  levels: Table<Level>,
  verticalPlacement: ComponentTransformVerticalPlacement,
  componentInstanceChain: string[],
): string {
  const { type } = verticalPlacement;
  switch (type) {
    case ComponentVerticalPlacementType.REPLICATION:
      const instanceLevelId = instanceIdForComponent(originalLevelId, componentInstanceChain);
      return levels[instanceLevelId]?.id ?? originalLevelId;
    case ComponentVerticalPlacementType.REMAPPING:
      return levels[verticalPlacement.levelRemapping[originalLevelId] ?? ""]?.id ?? originalLevelId;
    default:
      assertUnreachable(type);
  }
}
